/* -----------------UI--------------- */
import type { TextStyle } from "react-native";

/* -----------------Helpers & Hooks--------------- */
import { useDevice } from "../../useDevice";

/* -----------------Types--------------- */
import type { GetMessageActions } from "./types";

import { TTSContainer } from "@memorang/features/src/TTS";
import type { CustomFont } from "../../types";
/* -----------------Child components--------------- */
import Box from "../Box";
import { CustomListSubheader } from "../CustomListSubheader";
import { MessageActions } from "./MessageActions";
import { MessageMenuActions } from "./MessageMenuActions";
import ProfileIcon from "./ProfileIcon";

type Props = {
	showSummaryActions?: boolean;
	content?: string;
	subheader?: string;
	subHeaderStyle?: TextStyle;
	profileImageUri?: string | null;
	messageActions?: GetMessageActions;
	runId?: string;
	font?: CustomFont;
	id: string;
	streaming?: boolean;
};

export const MessageHeader = ({
	id,
	showSummaryActions,
	content,
	subheader,
	profileImageUri,
	messageActions,
	runId,
	font = "opensans",
	streaming,
}: Props) => {
	const { isMobile } = useDevice();

	const showSubheader = subheader && subheader.length > 0;

	return (
		<Box
			flexDirection="row"
			alignItems="center"
			justifyContent="space-between"
			height={40}
		>
			{showSubheader ? (
				<Box flexDirection="row" alignItems="center" gap={8}>
					<ProfileIcon uri={profileImageUri} />
					<CustomListSubheader
						enableGutters={false}
						style={[{ paddingLeft: 0 }]}
						font={font}
					>
						{subheader}
					</CustomListSubheader>
				</Box>
			) : (
				<Box />
			)}
			{showSummaryActions &&
				messageActions &&
				(isMobile ? (
					<Box flexDirection="row" alignItems="center">
						<TTSContainer
							itemId={id}
							explanation={content}
							size={18}
							disabled={streaming}
						/>
						<MessageMenuActions
							messageActions={messageActions}
							content={content}
							runId={runId}
						/>
					</Box>
				) : (
					<Box flexDirection="row" alignItems="center">
						<TTSContainer
							itemId={id}
							explanation={content}
							size={18}
							disabled={streaming}
						/>
						<MessageActions
							messageActions={messageActions}
							content={content}
							runId={runId}
						/>
					</Box>
				))}
		</Box>
	);
};
